import { Card } from '@/common/ui/Card/Card'
import { StatProgressBar } from '@/common/ui/StatProgressBar'
import { Icon } from '@/common/ui/Icon'
import type { GenerationBlockAvgScoreSchema, GenerationsAvgScoreSchema } from '@/common/api/client/types.gen'
import { DASHBOARD_BLOCK_TYPES, formatScoreValue } from '../lib/scoreColors'
import { getBlockTitle } from '../lib/labels'

type CompanyStatsContentBlocksProps = {
    scores: GenerationsAvgScoreSchema
}

export const CompanyStatsContentBlocks = ({ scores }: CompanyStatsContentBlocksProps) => {
    const dashboardBlocks = scores.blocks.filter(b => DASHBOARD_BLOCK_TYPES.includes(b.block_type))

    const weakestBlock = dashboardBlocks.reduce<GenerationBlockAvgScoreSchema | null>((min, block) => {
        const percent = block.percent ?? 0
        if (!min || percent < (min.percent ?? 0)) return block
        return min
    }, null)

    return (
        <Card color='primary' className='h-full'>
            <div className='flex items-start justify-between gap-4 mb-6'>
                <h3 className='text-xs font-bold uppercase tracking-wide text-white'>Блоки контента</h3>
                <span className='rounded-md bg-white/10 px-2 py-1 text-sm font-medium text-[#08AC81]'>
                    {formatScoreValue(scores.avg_score)} / {formatScoreValue(scores.max_score)}
                </span>
            </div>
            <div className='flex flex-col gap-5'>
                {dashboardBlocks.map(block => {
                    const percent = block.percent ?? 0
                    const label = getBlockTitle(block.block_type, block.title)
                    return (
                        <div key={block.block_type} className='flex flex-col gap-2'>
                            <div className='flex items-center justify-between gap-2 text-sm'>
                                <span className='text-base-content/90'>{label}</span>
                                <span className='font-medium tabular-nums'>{Math.round(percent)}%</span>
                            </div>
                            <StatProgressBar value={percent} aria-label={`${label}: ${Math.round(percent)}%`} />
                        </div>
                    )
                })}
            </div>
            {weakestBlock && (weakestBlock.percent ?? 0) < 80 ? (
                <div className='mt-6 flex gap-3 rounded-lg border border-[#F59E0B]/60 bg-[#F59E0B]/10 p-4' role='note'>
                    <Icon name='info-circle' size='md' className='shrink-0 text-[#F59E0B]' aria-hidden />
                    <p className='text-sm text-base-content/80'>
                        <span className='font-medium text-base-content'>Рекомендация: </span>
                        Слабейший блок: {getBlockTitle(weakestBlock.block_type, weakestBlock.title)} (
                        {Math.round(weakestBlock.percent ?? 0)}%). Сосредоточьте усилия на улучшении этого блока для
                        повышения общего рейтинга.
                    </p>
                </div>
            ) : null}
        </Card>
    )
}
